import Banner from 'components/Banner';
import researchBanner from 'images/research-banner.jpg';
import image1 from 'images/article-image-1.jpg';
import image2 from 'images/article-image-2.jpg';
import image3 from 'images/article-image-3.jpg';
import NewsSlider from 'components/NewsSlider';
import Label from 'components/Label';
import TextWithIcon from 'components/TextWithIcon';

const Research = () => (
    <div className="container">
        <Banner image={researchBanner} buttonText="LEARN MORE">
            <Label>Research</Label>
            <h2>Challenges of the 21st century</h2>
            <div>
                <TextWithIcon iconName="calendar" text={'25.08.2023'} />
                <TextWithIcon iconName="clock" text={'5 min to read'} />
            </div>
        </Banner>
        <article className="article-content">
            <h4>
                Microbial and viral pathogens, insect damage, weed infestation, and unknown nutrient deficiencies were
                the causes of poor harvests and even famine in Europe and around the world some 150-200 years ago.
            </h4>
            <h5>There are additional reasons for poor harvests in agriculture:</h5>
            <ul>
                <li>
                    <p>
                        <strong>Climate change: </strong>
                        With <a href="/#">climate change</a>, we are seeing more frequent and intense extreme weather
                        events such as heat waves, droughts, heavy rains, and freezing temperatures.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Environmental pollution: </strong>
                        Chemical contamination of soil, water and air can adversely affect plants and soil flora,
                        reducing yields and product quality.
                    </p>
                </li>
                <li>
                    <p>
                        <strong>Population growth: </strong>A growing global population requires more food from
                        <a href="/#"> agriculture</a>, which puts pressure on land resources and production volumes.
                    </p>
                </li>
            </ul>
            <hr />
            <p>
                Over the past century, extensive scientific research and the implementation of its results in
                traditional agriculture have significantly reduced the impact of the above factors. During this period,
                average yields have doubled or tripled and, as a result, significant improvements in food security have
                been achieved.
            </p>
            <figure>
                <img src={image1} alt="" />
                <figcaption>
                    Data source: Günter Mahlerwein: Modernity 1880-2010, Foundations of the History of Agriculture,
                    volume 3, Cologne/Weimar/Vienna, 2016, p. 150.
                </figcaption>
            </figure>
            <hr />
            <p>
                However, over the past few decades, yield increases seem to have slowed or even stopped. As an example,
                we can analyze wheat yields over the past 20 years in Germany.
            </p>
            <figure>
                <img src={image2} alt="" />
                <figcaption>
                    Data source: Federal Statistical Office, series 3, number 3.2.1; Annual Journal Table: Cultivation,
                    Yield and Harvest of Crops.
                </figcaption>
            </figure>
            <hr />
            <p>
                On the one hand, the reason for this is undoubtedly the reduction in the list of permitted plant
                protection products and stricter rules for nitrogen and phosphorus fertilizers. However, the growing
                impact of abiotic stress from heat, drought, frost, excessive radiation, and heavy rain is probably more
                significant. In the context of climate change, there is an increase in the frequency of these extreme
                weather events, which will also be predicted by leading climate researchers in the future.
            </p>
            <p>
                Abiotic stress can be partially reduced through technical techniques, as is already practiced, for
                example, through targeted breeding of resistant varieties and hybrids, differentiated fertilization and
                irrigation. However, this is not always economically and environmentally feasible, or breeding
                justified.
            </p>
            <hr />
            <h4>
                Looking to the future, despite the increase in extreme weather events, it will be even more important to
                increase the environmental potential of crop yields.
            </h4>
            <p>
                As a result, agriculture can increase yields and look to the future with less concern about climate
                change. The use of targeted biostimulants makes it possible to mitigate the impact of abiotic stressors
                on yields by triggering the plant's natural defense mechanisms to counteract stress.
            </p>
            <figure>
                <img src={image3} alt="" />
                <figcaption>
                    Data source: Plant Biochemistry and Molecular Biology, Buchanan, Grussem, Jones, American Society of
                    Plant Physiology, 2000.
                </figcaption>
            </figure>
            <h5>Additional ways to increase the environmental potential of crop yields:</h5>
            <ol>
                <li>
                    <p>Effective management of water resources;</p>
                </li>
                <li>
                    <p>Integrated pest management;</p>
                </li>
                <li>
                    <p>Improvement of plant genetic resources;</p>
                </li>
                <li>
                    <p>Irrigation on request;</p>
                </li>
                <li>
                    <p>Sustainable management systems.</p>
                </li>
            </ol>
            <blockquote>
                On June 15, 2023, Betino® received confirmation from <a href="/#">Organic Standard</a> of its approval
                for use in organic agriculture in accordance with the standard of internationally accredited
                certification bodies for organic production and processing, which is equivalent to the European Union
                Regulations No. 834/2007 and 889/2008.
            </blockquote>
        </article>
        <NewsSlider />
    </div>
);

export default Research;
